import { IconStar, IconStarFilled } from '@tabler/icons-react'
import type { JSX, MouseEvent } from 'react'
import { Button } from '#src/components/Button/Button.tsx'

export interface StarToggleProps {
  active: boolean
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void
  disabled?: boolean
  label?: string
}

export function StarToggle({
  active,
  onClick,
  disabled,
  label,
}: StarToggleProps): JSX.Element | null {
  const resolvedLabel = label ?? (active ? 'Starred' : 'Not starred')
  const icon = active ? (
    <IconStarFilled className="size-4 text-primary" />
  ) : (
    <IconStar className="size-4 text-muted-foreground" />
  )

  if (!onClick) {
    return active ? (
      <span role="img" aria-label={resolvedLabel} title={resolvedLabel}>
        {icon}
      </span>
    ) : null
  }

  return (
    <Button
      variant="ghost"
      size="icon-sm"
      onClick={onClick}
      disabled={disabled}
      aria-label={resolvedLabel}
      title={resolvedLabel}
    >
      {icon}
    </Button>
  )
}
